// services/atualizarApartamento.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";

export const cadastrarArquivosReserva = async (dataReserva: any) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/arquivos-reserva`;
    try {
      const response = await axios.post(URL, dataReserva, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
